var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.465 8.36643C6.545 10.4889 8.285 12.2214 10.4075 13.3089L12.0575 11.6589C12.26 11.4564 12.56 11.3889 12.8225 11.4789C13.6625 11.7564 14.57 11.9064 15.5 11.9064C15.9125 11.9064 16.25 12.2439 16.25 12.6564V15.2739C16.25 15.6864 15.9125 16.0239 15.5 16.0239C8.4575 16.0239 2.75 10.3164 2.75 3.27393C2.75 2.86143 3.0875 2.52393 3.5 2.52393H6.125C6.5375 2.52393 6.875 2.86143 6.875 3.27393C6.875 4.21143 7.025 5.11143 7.3025 5.95143C7.385 6.21393 7.325 6.50643 7.115 6.71643L5.465 8.36643Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.c477c7465c614d01b488e7cb597fbf80.svg";
export { ForwardRef as ReactComponent };